import React from 'react';
import Select from 'react-select';
import { currencies, taxTypes } from '../../../../utils/select-fields';
import TypeControlledTextField from '../../../tc-ui/type-controlled-textfield.jsx';


const TaxCurrencyCommissionForm = props => {
  return (
    <div>
      <div style={{ margin: '24px auto', display: props.hideCurrencyTax ? 'none' : 'block' }}>
        <span style={{ position: 'relative', top: '-12px' }}>Tax information <small style={{ color: 'red', display: !props.taxInclusion && !props.taxType ? 'block' : 'none' }}> * Required</small></span>
        <div style={{ display: 'inline-block', marginLeft: '12px' }}>
          <div style={{ width: '140px', display: 'inline-block' }}>
            <Select
              name="taxInclusion"
              options={[
                { value: 'inclusive', label: 'Tax inclusive' },
                { value: 'exclusive', label: 'Tax exclusive' },
                { value: 'exempt', label: 'Tax exempt' },
              ]}
              value={props.taxInclusion}
              onChange={({ value }) => props.updateFunc('taxInclusion', value.trim())}
              placeholder="Tax Inclusion"
              clearable={false}
              scrollMenuIntoView={false}
            />
          </div>
          {
            props.taxInclusion !== 'exempt' ?
              <div style={{ width: '160px', marginLeft: '50px', display: props.hideCurrencyTax ? 'none' : 'inline-block' }}>
                <Select
                  name="taxType"
                  options={taxTypes}
                  value={props.taxType}
                  onChange={({ value }) => props.updateFunc('taxType', value.trim())}
                  placeholder="Tax Type"
                  clearable={false}
                  scrollMenuIntoView={false}
                />
              </div> : undefined
          }
        </div>
      </div>

      <div style={{ margin: '24px auto', display: props.hideCurrencyTax ? 'none' : 'block' }}>
        <span style={{ position: 'relative', top: '-12px' }}>Currency <small style={{ color: 'red', display: !props.currency ? 'block' : 'none' }}> * Required</small></span>
        <div style={{ width: '160px', marginLeft: '48px', display: 'inline-block' }}>
          <Select
            name="currency"
            options={currencies}
            value={props.currency}
            onChange={({ value }) => props.updateFunc('currency', value.trim())}
            placeholder="Currency"
            clearable={false}
            scrollMenuIntoView={false}
          />
        </div>
      </div>
      <div>
      <TypeControlledTextField
        id={`commission`}
        controlledType="number"
        style={{ display: 'inline-block', width: '50%' }}
        hintStyle={{ fontSize: '14px' }}
        floatingLabelShrinkStyle={{ color: 'rgba(0, 0, 0, 0.64)' }}
        inputStyle={{ fontSize: '14px' }}
        floatingLabelText={props.rateType === 'includeCommission' || (!props.rateType && props.commissionPercentage) ? 'COMMISSION: ' : 'NETT RATE BASED ON COMMISSION: '}
        value={props.rateType === 'includeCommission' || (!props.rateType && props.commissionPercentage) ? props.commissionPercentage : props.nettCommission}
        onChange={({ target: { value } }) => {
          props.updateFunc(props.rateType === 'includeCommission' || (!props.rateType && props.commissionPercentage) ? 'commissionPercentage' : 'nettCommission', value);
        }}
      />
      </div>
      <div style={{ margin: '24px auto' }}>
        If you need to fine tune these rates, just edit the table below.
      </div>
    </div>
  );
};

export default TaxCurrencyCommissionForm;




// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/rate-forms/tax-currency-commission-form.jsx